import { css } from '@emotion/react'
import { Button, Heading, HFlow, Text, Theme, Tooltip, useTheme, VFlow } from 'bold-ui'
import { ReactComponent as AvisoCidadaoVulnerabilidadeIcon } from 'images/prontuario-familiar/cidadao_aviso_vulnerabilidade.svg'
import { useState } from 'react'
import { ModalClassificacaoVulnerabilidade } from 'view/atendimentos/detail/prontuario-familiar/acompanhamento-vulnerabilidade/ModalClassificacaoVulnerabilidade'

export function AlertCriteriosSugestivos() {
  const theme = useTheme()
  const styles = createStyles(theme)

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [isVisible, setIsVisible] = useState<boolean>(true)

  const handleClose = () => setIsModalOpen(false)
  const handleOpen = () => setIsModalOpen(true)
  const handleHideAlert = () => setIsVisible(false)

  if (!isVisible) return null

  return (
    <>
      <ModalClassificacaoVulnerabilidade isModalOpen={isModalOpen} onClose={handleClose} />

      <HFlow hSpacing={1} alignItems='flex-start' justifyContent='space-between' style={styles.container}>
        <HFlow hSpacing={1} alignItems='center'>
          <AvisoCidadaoVulnerabilidadeIcon css={styles.img} />
          <VFlow>
            <VFlow vSpacing={0.2} style={styles.text}>
              <Heading level={3}>Estratificação de vulnerabilidade familiar no e-SUS APS</Heading>
              <Text>
                Essa informação ajuda a equipe a identificar situações que precisam de mais atenção e a organizar melhor
                o cuidado no território.
              </Text>
            </VFlow>

            <Button onClick={handleOpen} skin='ghost' kind='primary' size='small' style={styles.button}>
              Saiba mais
            </Button>
          </VFlow>
        </HFlow>

        <Tooltip text='Fechar'>
          <Button onClick={handleHideAlert} skin='ghost' size='small' style={styles.closeBtn}>
            <span>&times;</span>
          </Button>
        </Tooltip>
      </HFlow>
    </>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    padding: 0.5rem 1rem;
    border: 1px solid ${theme.pallete.gray.c80};
    background-color: ${theme.pallete.surface.main};
    border-radius: 0.75rem;
    width: 100%;
  `,
  text: css`
    max-width: 55rem;
  `,
  img: css`
    align-self: center;
  `,
  button: css`
    align-self: flex-start;
    margin-left: -0.5rem;
    margin-top: -0.5rem;

    &:focus,
    &:active {
      outline: none;
      box-shadow: none;
    }
  `,
  closeBtn: css`
    width: 48px;
    height: 32px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -0.25rem;
    margin-right: -1rem;
    border-radius: 0.25rem;
    color: ${theme.pallete.gray.c10};
    font-size: 2rem;
    font-weight: 200;
    font-family: 'Helvetica', 'Arial', sans-serif;

    &:hover {
      background-color: ${theme.pallete.gray.c90};
      color: ${theme.pallete.gray.c10};
    }

    &:focus,
    &:active {
      outline: none;
      box-shadow: none;
    }

    & span {
      display: block;
      line-height: 1;
      transform: translateY(-2px);
    }
  `,
})
